import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Card from '@/components/Card/Card';
import CardHeader from '@/components/Card/CardHeader';
import CardBody from '@/components/Card/CardBody';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ProcessingExceptions from './ProcessingExceptions';

const Exceptions = ({ role }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Card>
      <CardHeader
        style={{ display: 'flex', justifyContent: 'space-between' }}
        color='primary'>
        <h4>{t('exceptions.title')}</h4>
      </CardHeader>
      <CardBody>
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab label={t('exceptions.tabs.processingExceptions')} />
          {/* <Tab label='Communication Exceptions' /> */}
        </Tabs>
        {activeTab === 0 && <ProcessingExceptions role={role} />}
        {/* {activeTab === 1 && <div>Communication Exceptions</div>} */}
      </CardBody>
    </Card>
  );
};

export default Exceptions;
